/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=62a61a9f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=62a61a9f&lang=less"

import exportComponent from "D:\\dianzhong\\cps-expert-popularize\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__